import React from 'react';
import { Create } from 'react-admin';
import UserForm from './UserForm';

const UserCreate = () => {
  return (
    <Create title="Create New User">
      <UserForm isEdit={false} />
    </Create>
  );
};

export default UserCreate;
